import Hotjar from '@hotjar/browser';
import { browser } from '$app/environment';
import { PUBLIC_HOTJAR_SITE_ID } from '$env/static/public';

const siteId = parseInt(PUBLIC_HOTJAR_SITE_ID);
const hotjarVersion = 6;

class HotjarService {
  constructor(siteId: number, hotjarVersion: number) {
    if (browser && siteId) Hotjar.init(siteId, hotjarVersion);
  }
}

export const hotjarService = new HotjarService(siteId, hotjarVersion);
